import axios from 'axios';

const BASE_URL = '/api/billing-reconciliation';

export const getBillingReconciliationOptimizationSettings = async ({ signal } = {}) => {
  const { data } = signal
    ? await axios.get(`${BASE_URL}/settings/optimization`, { signal })
    : await axios.get(`${BASE_URL}/settings/optimization`);
  return data;
};

export const updateBillingReconciliationOptimizationSettings = async (updates = {}) => {
  const { data } = await axios.patch(`${BASE_URL}/settings/optimization`, updates);
  return data;
};
